<template>
<div>
	<no-data v-if="dataLoadState && feedbackList.length === 0"></no-data>
	<div class="container container--narrow pdt-50">
		<div class="d-flex leader-list pdt-24 pdb-23 pdr-24 " v-for="(feedback, index) in feedbackList" :key="index">

			<div class="pdt-4 mgr-20">
					<member-profile :profile="feedback.member.profile">
										{{feedback.member.name.fullName ? feedback.member.name.fullName.charAt(0).toUpperCase() : ''}}
					</member-profile>
			</div>
			<div class="d-flex flex-column flex-grow-1 pdr-16">
				<div class="d-flex align-items-baseline">
					<div class="t-body1 font-r l-spacing48 t-color-bodyGrayA">{{ feedback.member.name?$t('3437',{first: feedback.member.name.first, last: feedback.member.name.last}):''}}</div>
					<div class="mgl-8 t-helper font-r t-color-bodyGrayA"> {{$moment(feedback.date).fromNow()}}</div>
				</div>
				<div class="t-body6 mgt-6 t-color-bodyGrayA font-r">{{feedback.text}}</div>
			</div>

		</div>
	</div>
<div class="footer bg-white bottomStack">
<div class="divider"></div>
<div class="container container--narrow pdb-0">
<div class="d-flex align-items-center justify-content-between pdt-4 pdb-4">
	
<div class="d-flex flex-grow-1 ">
	<form class="d-flex flex-grow-1 " @submit.prevent="" novalidate>
			<textarea
							class="mdc-text-field__input t-body6 font-r l-spacing42  mgt-16 mgb-16 pdl-8 pdr-16 t-color-textfieldGuid"
							rows="1" 
							@keyup="resizeIt($event.target.value)"
							:placeholder="$t('171')" 
							v-model="text" 
							id="autoheighttext"></textarea>
			<button @click="sendFeedback()" @keypress="sendFeedback()" tabindex="0" class="mdc-icon-button sendMessageBtn t-color-white align-items-center justify-content-between">
				<i	class="material-icons  min-w-24 min-h-24">arrow_upward</i></button>
		</form>
</div>
</div>
</div>
</div>
<div class="mgt-50"></div>
</div>
</template>

<script>
/**
 * 나의 학습 상세 - 미션 피드백 컴포넌트(my learning view - mission feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from '@/api/learnApi.js'
import NoData from '../../common/NoData.vue'
import MemberProfile from '../../common/MemberProfile.vue'

export default {
	data() {
		return {
			learnId: null,
			assignmentId: null,
			feedbackList: [],
			dataLoadState: false,
			text: '',
		}
	},
	components: {
		'no-data': NoData,
		'member-profile': MemberProfile
	},
	mounted() {
		this.learnId = this.$route.params.learnId,
		this.assignmentId = this.$route.params.assignmentId
		this.fatchData()
	},

	computed: {
		isText() {
			return !!this.text
		}
	},
	updated() {
		setTimeout(() => {
			this.moveScrollBottom()                
		}, 100);
		
	},
	methods: {
			resizeIt(str) {
	  var elmnt = document.getElementById("autoheighttext");
	  elmnt.style.height = 0;
	  var scHeight = elmnt.scrollHeight;
	  elmnt.style.height = scHeight + "px";
	},
		// 피드백 목록 API 호출(get feedback list data)
		fatchData() {
			let params = this.setParams()

			learnApi.learnViewMissionFeedback(params).then((response) => {
				// console.log('learnViewMissionFeedback', response.data.data)
				this.feedbackList = response.data.data
				this.dataLoadState = true
			})
		},

		// 피드백 등록 API 호출(regist feedback)
		sendFeedback() {
			let params = this.setParams()

			learnApi.learnViewMissionFeedbackSubmit(params).then((response) => {
				this.fatchData()
				this.text = ''
			})

		},

		// 피드백 삭제 API 호출(delete feedback)
		deleteFeedback(feedbackId) {
			let params = {
				learnId: this.learnId,
				assignmentId: this.assignmentId,
				feedbackId: feedbackId
			}

			learnApi.learnViewMissionFeedbackDelete(params).then((response) => {
				this.fatchData()
			})

		},

		// 스크롤 바닥으로 이동(move scroll to bottom)
		moveScrollBottom() {
			let element = this.$refs.scrollBottom
			let options = {
				container: this.$refs.scrollBody,
				easing: 'ease-in'
			}
			this.$scrollTo(element, 100, options)
		},

		// 파라미터 설정(set parameter)
		setParams() {
			let params = {
				learnId: this.learnId,
				assignmentId: this.assignmentId,
				text: this.text
			}
			return params
		}


	}
}
</script>
